import { CognitoAdapterBase } from "../../../services/auth/cognito-adapter-base";
import type { ServiceKey } from "../../../services/auth/types";

/**
 * MyQueue authenticates against Cognito (separate pool from Engage) and
 * emits this header set on every API call:
 *
 *   authorization: Bearer <id token>   // Bearer-prefixed, ID token (not access)
 *   x-api-key:     <api key>
 *   poolid:        <userPoolId>
 *   region:        <aws region>
 *
 * Note the asymmetry with EngageAuthAdapter:
 *   - Engage sends the access token in `authorization` without "Bearer".
 *   - MyQueue sends the ID token in `authorization` with "Bearer".
 *
 * The difference is dictated by the backend services' validators, not us —
 * keep the styles separate.
 */
export class MyQueueAuthAdapter extends CognitoAdapterBase {
  readonly key: ServiceKey = "myqueue";
  readonly category = "tasks";

  getAuthHeaders(): Record<string, string> {
    if (!this.tokens) return {};
    const headers: Record<string, string> = {
      authorization: `Bearer ${this.tokens.idToken}`,
      poolid: this.cfg.poolId,
      region: this.cfg.region,
    };
    if (this.cfg.apiKey) {
      headers["x-api-key"] = this.cfg.apiKey;
    }
    return headers;
  }
}

/**
 * Variant registered under the "myqueue-tasks" systemName. Shares the
 * canonical `key = "myqueue"` so integration hooks (`useMyQueueClient`,
 * `MyQueueModule`) resolve the adapter regardless of which backend
 * connector identity the persona is provisioned with.
 */
export class MyQueueTasksAuthAdapter extends MyQueueAuthAdapter {}
